quoteModule.controller('quoteDealInfoController',
['$scope', '$rootScope', '$window', 'quoteCreationEvents', 'erateSessionVarsService','DealInfo','quoteIntegrationService',
    'rateQuoteCoordService','quoteIntegrationConstants','rateQuoteRetrievalCoordService',
    'quoteInitializationService', 'lenderRetrievalService', 'contractCreationService', 'tuxFabMenuEvents',
    '$mdDialog','$filter', 'locationService','TLCError','AppErrorCodes','dealProductService',  'vehicleProductsProcessingService',
function ($scope, $rootScope, $window, quoteCreationEvents, erateSessionVarsService,DealInfo, quoteIntegrationService,
          rateQuoteCoordService,quoteIntegrationConstants, rateQuoteRetrievalCoordService,
          quoteInitializationService, lenderRetrievalService, contractCreationService, tuxFabMenuEvents,
          $mdDialog, $filter, locationService, TLCError, AppErrorCodes, dealProductService, vehicleProductsProcessingService) {
    var self = this;
    /*
    This controller reacts to changes in the deal (financial) information.. Amount financed, APR, etc. Anytime
    the fields are changed, we cast an event in case we need to re-rate. If the deal data is complete, we
    cast an event to attempt to save the quote. Please note we don't really save the quote until all minimum
    fields are captured and at least one rate is chosen.

    When we first come into this controller, we first see if we are "integrating" with something else, or
    retrieving an existing quote. We fill in the data from the captured fields.
     */

    //deal scope data
    $scope.dealDefinition = {};
    $scope.dealDefinitionPrevious = {
        prevTermMonths: 0,
        prevFinanceRate: 0,
        prevAmountFinanced: 0,
        prevSellingPrice: 0,
        prevMSRP: 0
    };

    $scope.lenderInfoPrevious = {
        name: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: ""
    };

    $scope.lenderInfo;
    $scope.contractsProcessing = contractCreationService.contractsProcessing;
    $scope.quoteMode = null;
    $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
    $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;
    $scope.priceMin = 0;
    //
    //COM-808 we will assume if deal information changes we DO NOT re-rate except
    // those products that depend on finance data (GAP mainly)
    $scope.productsToReRateAfterDealChange = [];
    
    //initialize the directive with the controller
    this.init = function (element) {
        self.$element = element;
        rateQuoteCoordService.clearDeal();
        rateQuoteCoordService.clearLender();
        $scope.dealDefinition= rateQuoteCoordService.DealData;
        $scope.lenderInfo = rateQuoteCoordService.LenderData;
        $scope.getDealerLenders();
        $scope.quoteMode = erateSessionVarsService.getQuotingMode();
        quoteInitializationService.signalChildReady('dealReady');

        var vType = erateSessionVarsService.getCurrentDealerVehicleType();
        if (vType == null) {vType = 'AUTO';}
        $scope.priceMin = (vType == 'RV' || vType == 'RVAUTO') ? 1000 : 0;
        //what products re-rate based on deal info changing?
        dealProductService.getProductsReRateOnDealChange()
        .then(
            function gotProds(response){
                $scope.productsToReRateAfterDealChange = response;
            }
        );
    };

    //deal information changed..
    $scope.dealInfoChanged = function(doNotSignalDealChange){
        //something has changed, so we likely need to re-quote or save
        rateQuoteRetrievalCoordService.endQuoteRetrieval();
        //broadcasting the deal change to the customer-card-controller
       /* if (!doNotSignalDealChange) {
            //including the products that need to be re-rated if the deal changes in the event.
            $rootScope.$broadcast(quoteCreationEvents.dealDataChanged,
                {
                    dealData : $scope.dealDefinition,
                    prodsToReRate : $scope.productsToReRateAfterDealChange
                }
                );
        }*/
    }

    $scope.$on(quoteCreationEvents.loadingExistingQuote, function(event, args) {
        // (COM-808)
        //if we are menu-integrated, we need to get latest deal information from there and
        // not from the retrieved quote
        if ($scope.quoteMode == $scope.menuQuoteIntegrated || $scope.quoteMode == $scope.menuContractIntegrated){
            var appPrefillData = quoteIntegrationService.getIntegrationData();
            rateQuoteCoordService.DealData = new DealInfo();
            rateQuoteCoordService.DealData.consumeFromMenuIntegration(appPrefillData.financialDatas[0]);
            $scope.dealDefinition = rateQuoteCoordService.DealData;

            var lenderCode = appPrefillData.lenderCode ? appPrefillData.lenderCode.toUpperCase() : null;
            appPrefillData = null;//done with it here
            if (lenderCode){
                var lender = $filter('filter')(rateQuoteCoordService.LenderData.options, {"code": lenderCode});
                if (lender && lender.length > 0){
                    rateQuoteCoordService.LenderData.selectedLender = lender[0];
                }
            }
        }else{
            $scope.dealDefinition = rateQuoteCoordService.DealData;
        }
    });
    //we are starting a new quote session
    $scope.$on(quoteCreationEvents.startNewProductQuote, function(event, args) {
        $scope.setupDealInfo(false);//new product.. don't start rating until vehicle is ready
    });
    //we retrieved an existing quote -- fill in the values
    $scope.$on(quoteCreationEvents.dealDataRetrieved, function(event, dealArgs) {
        //custArgs in models/customer-info.js
        $scope.dealDefinition = rateQuoteCoordService.DealData;
    });
    //check to see if we are integrating with some external source, or retrieving an existing quote.
    $scope.setupDealInfo = function(signalDealInfoChanged){
        $scope.dealDefinition = null;
        quoteInitializationService.initializeDealData();
        $scope.dealDefinition= rateQuoteCoordService.DealData;
        //get the lender code from integration and set it to the selected lender item
        if ($scope.quoteMode == $scope.menuQuoteIntegrated || $scope.quoteMode == $scope.menuContractIntegrated){
            var appPrefillData = quoteIntegrationService.getIntegrationData();
            var lenderCode = appPrefillData.lenderCode ? appPrefillData.lenderCode.toUpperCase() : null;
            appPrefillData = null;//done with it here
            if (lenderCode){
                var lender = $filter('filter')(rateQuoteCoordService.LenderData.options, {"code": lenderCode});
                if (lender && lender.length > 0){
                    rateQuoteCoordService.LenderData.selectedLender = lender[0];
                }
            }
        }

        $scope.dealDefinition = rateQuoteCoordService.DealData;
        if (!rateQuoteRetrievalCoordService.inQuoteRetrieval())
            $scope.dealInfoChanged(signalDealInfoChanged);
    };
    /*
    ********************
    LENDER section - fields and methods for the lender portion of
    ********************
     */
    //the lender has changed, so let's save changes (if we can)
    $scope.lenderChanged = function(){

        //need to add validation of some sort before "capturing"
        if ($scope.dealDefinition && $scope.dealDefinition.dataReadyToSaveQuote()) {
            $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave, {});
        }
    };

    //retrieve the dealership's set-up lenders
    $scope.getDealerLenders = function() {
        lenderRetrievalService.retrieveLenderOptions()
        .then(
            function(lenderData) {
                rateQuoteCoordService.LenderData.options = lenderData.options;
                rateQuoteCoordService.LenderData.notApplicableLender
                    = rateQuoteCoordService.LenderData.selectedLender
                    = lenderData.notApplicableOption;
            },
            function(err){
                throw new TLCError(new Error(error),AppErrorCodes.DealInfoController_LoadLendersError);
            }
        );
    };

    /*
    *********************
    Verifying that information changed, and if so trigger requoting
    *********************
     */
    // Determines if the deal information has changed.
    function hasDealChanged() {

        var dealchng = parseFloat($scope.dealDefinition.financeRate) != parseFloat($scope.dealDefinitionPrevious.prevFinanceRate) ||
            parseFloat($scope.dealDefinition.amountFinanced) != parseFloat($scope.dealDefinitionPrevious.prevAmountFinanced) ||
            parseFloat($scope.dealDefinition.sellingPrice) != parseFloat($scope.dealDefinitionPrevious.prevSellingPrice) ||
            parseInt($scope.dealDefinition.termMonths) != parseInt($scope.dealDefinitionPrevious.prevTermMonths);

        return dealchng;
    };

    function hasLenderChanged(){
        $scope.lenderInfoPrevious
        if ( $scope.lenderInfo.selectedLender.name != $scope.lenderInfoPrevious.name ||
            $scope.lenderInfo.selectedLender.address1 != $scope.lenderInfoPrevious.address1||
            $scope.lenderInfo.selectedLender.address2 != $scope.lenderInfoPrevious.address2 ||
            $scope.lenderInfo.selectedLender.city != $scope.lenderInfoPrevious.city ||
            $scope.lenderInfo.selectedLender.state != $scope.lenderInfoPrevious.state ||
            $scope.lenderInfo.selectedLender.zip != $scope.lenderInfoPrevious.zip) {
            return true;
        }
        return false;
    }

    function saveLender() {
        //Save a new lender if not already saved
        if (!$scope.fabMenu.$invalid && hasLenderChanged()) {
            lenderRetrievalService.retrieveLenderOptions()
                .then(
                    function (lenderData) {
                        rateQuoteCoordService.LenderData.notApplicableLender = rateQuoteCoordService.LenderData.selectedLender;

                        //Does our lender exist in db?
                        foundLender = _.filter(lenderData.options, function (element) {
                            return element.name == $scope.lenderInfo.selectedLender.name && element.address1 == $scope.lenderInfo.selectedLender.address1 && element.address2 == $scope.lenderInfo.selectedLender.address2 && element.city == $scope.lenderInfo.selectedLender.city && element.code == $scope.lenderInfo.selectedLender.code && element.isDefault == $scope.lenderInfo.selectedLender.isDefault
                        });

                        if (foundLender.length == 0 && rateQuoteCoordService.LenderData.selectedLender.name != lenderData.notApplicableOption) {
                            //Now lets save the lender on FAB to db
                            lenderRetrievalService.saveLender($scope.lenderInfo.selectedLender)
                                .then(
                                    function (response) {
                                        //refresh

                                    }, function (err) {
                                        throw new TLCError(new Error(err), AppErrorCodes.DealInfoController_SaveLendersError);
                                    });
                        }
                    },
                    function (err) {
                        throw new TLCError(new Error(error), AppErrorCodes.DealInfoController_LoadLendersError);
                    }
                );
        }
    }

    function changeProceed(vehicleChanged, dealChanged, productSelectionChanged){
        //if the vehicle info changed, then re-rate everything
        if (vehicleChanged){
            // the vehicle changed, we need to change the FirstQuote to False, and signal the vehicleChange
            $rootScope.$broadcast(quoteCreationEvents.vechicleDataChangedProceed, true);
        //deal only changed, so re-rate only those products
        }
        else if (dealChanged){
            $rootScope.$broadcast(quoteCreationEvents.dealDataChanged,
                {
                    dealData : $scope.dealDefinition,
                    prodsToReRate : $scope.productsToReRateAfterDealChange
                });
        }
        else if (productSelectionChanged) {
            $rootScope.$broadcast(quoteCreationEvents.filteringProductsSelected, {});
        }

        if (vehicleProductsProcessingService.getForceLoadProducts()){
            $rootScope.$broadcast(quoteCreationEvents.cleanRatesFromQueue, {});
            $rootScope.$broadcast(quoteCreationEvents.filteringProductsSelected, {});
        }
    }

    $scope.$on(tuxFabMenuEvents.closed, function () {
        //var vehicleChanged = JSON.parse($window.sessionStorage.getItem('SESS_VEHICLE_CHANGED'));
        var vehicleChanged = vehicleProductsProcessingService.getVehicleInfoDataChanged();
        var dealChanged = hasDealChanged();
        var productSelectionChanged = (vehicleProductsProcessingService.getFilteringProductsChanged() || vehicleProductsProcessingService.getForceLoadProducts());
        $scope.reQuote(vehicleChanged, dealChanged, productSelectionChanged);
        saveLender();
    });

    // Saves initial Vehicle definition values.
    $scope.$on(tuxFabMenuEvents.shown, function (tuxFabTab) {
        $scope.dealDefinitionPrevious.prevTermMonths = $scope.dealDefinition.termMonths;
        $scope.dealDefinitionPrevious.prevFinanceRate = $scope.dealDefinition.financeRate;
        $scope.dealDefinitionPrevious.prevAmountFinanced = $scope.dealDefinition.amountFinanced;
        $scope.dealDefinitionPrevious.prevSellingPrice = $scope.dealDefinition.sellingPrice;
        $scope.dealDefinitionPrevious.prevMSRP = $scope.dealDefinition.MSRP;

        //Previously entered Lender Info
        $scope.lenderInfoPrevious.name =$scope.lenderInfo.selectedLender.name ;
        $scope.lenderInfoPrevious.address1 =  $scope.lenderInfo.selectedLender.address1;
        $scope.lenderInfoPrevious.address2 = $scope.lenderInfo.selectedLender.address2 ;
        $scope.lenderInfoPrevious.city =    $scope.lenderInfo.selectedLender.city;
        $scope.lenderInfoPrevious.state = $scope.lenderInfo.selectedLender.state;
        $scope.lenderInfoPrevious.zip = $scope.lenderInfo.selectedLender.zip;
    });

    // mdDialog, displays confirmation message when term > 0 and Amt Financed > 0 and APR >= 0 and there was a change on them or on the selling price or the MSRP
    $scope.reQuote = function(vehicleChanged, dealChanged, productSelectionChanged) {
        if ( $scope.displayingAlertInvalid )
            return;
        //can change vehicle cert/usage info when quote integrated
        if ($scope.quoteMode == $scope.menuContractIntegrated)
            return;
        changeProceed(vehicleChanged, dealChanged, productSelectionChanged);

    };

    $scope.aprEntered = function(){
        if ($scope.dealDefinition.financeRate && $scope.dealDefinition.financeRate.toString().length >11)
            $scope.dealDefinition.financeRate = parseInt($scope.dealDefinition.financeRate.toString().slice(0,11));
    }

    $scope.getSaleTypeDescription = function(saleType){
        switch(saleType){
            case 'RetailFinanced':
                return 'Loan';
            case 'BalloonFinanced':
                return 'Balloon';
            case 'Leased':
                return 'Lease';
            default:
                return saleType;
        }
    };

    $scope.lookupSelectedLenderLocationByZipCode = function(zipCode) {
        locationService.getLocationInfoFromZipCode(zipCode)
            .then(function(data) {
                _.extend($scope.lenderInfo.selectedLender, data);
            });
    };
}]);
